import { render, staticRenderFns } from "./FollowUpPatientStep9Component.vue?vue&type=template&id=b63e6686&scoped=true&"
import script from "./FollowUpPatientStep9Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep9Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep9Component.vue?vue&type=style&index=0&id=b63e6686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63e6686",
  null
  
)

export default component.exports